import { config } from '@/config/config';
import { api } from '@/shared/services/baseApiClient';
import { QueryStringBuilder } from '@/shared/services/queryStringBuilder';
import urljoin from 'url-join';
import { Data, DateGrouping } from '../models';

export interface MessagingReportsRequest {
  startDate: Date;
  endDate: Date;
  grouping: DateGrouping;
}

export interface MessagingReportsData {
  newContactsTrendReport?: Data;
  newConversationsTrendReport?: Data;
}

class MessagingReportsApi {
  private readonly version = 'v1';
  public loadReportData(workspaceId: string, request: MessagingReportsRequest): Promise<MessagingReportsData> {
    const query = new QueryStringBuilder()
      .add('startDate', request.startDate.toISOString())
      .add('endDate', request.endDate.toISOString())
      .add('grouping', request.grouping)
      .build();

    return api.send('GET', urljoin(config().messagingHost, this.version, workspaceId, `reports`) + query);
  }
}

export const messagingReportsApi = new MessagingReportsApi();
